import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/index", //重定向
    meta:{
      noNeedCheckLogin: true,
    }
  },
  {
    path: "/index",
    name: "index",
    component: () => import("../views/home/index.vue"),
    meta:{
      noNeedCheckLogin: true,
    }
  },
  {
    path: "/source",
    name: "source",
    component: () => import("../views/suyuan/index.vue"),
    meta:{
      noNeedCheckLogin: true,
    title:'产品溯源'

    }
  },
  {
    path: "/shopIndex",
    name: "shopIndex",
    component: () => import("../views/shop/index.vue"),
    children: [
      {
        name: "index",
        path: "/shopIndex",
        component: () => import("../views/index/index.vue"),
        meta: {
          title: "商品首页",
          noNeedCheckLogin: true,
        },
      },
      {
        name: "jingPing",
        path: "/jingPing", //精品推荐
        component: () => import("../views/jingPing/index.vue"),
        meta: {
          title: "精品推荐",
          noNeedCheckLogin: true,
        },
      },
      {
        name: "famous",
        path: "/famous", //名优产品
        component: () => import("../views/Famous/index.vue"),
        meta: {
          title: "名优产品",
          noNeedCheckLogin: true,
        },
      },
      {
        name: "more",
        path: "/more", //更多产品
        component: () => import("../views/more/index.vue"),
        meta: {
          title: "更多产品",
          noNeedCheckLogin: true,
        },
      },
      {
        name: "toggleArea",
        path: "/toggleArea", //全部商品-地区切换
        component: () => import("../views/toggleArea/index.vue"),
        meta: {
          title: "地区切换",
          noNeedCheckLogin: true,
        },
      },
    ],
  },
  {
    path: "/shangquan",
    name: "shangquan",
    component: () => import("../views/business/homepage.vue"),
    meta: {
      title: "商圈",
      noNeedCheckLogin: true,
    },
  },
  {
    path: "/district",
    name: "district",
    component: () => import("../views/business/district.vue"),
    meta: {
      title: "商圈",
    },
  },
  {
    path: "/modelPicture",
    name: "modelPicture",
    component: () => import("../views/modelPicture/index.vue"),
    meta: {
      title: "名片模型",
      noNeedCheckLogin: true,
    },
  },
  {
    path: "/liveBroad",
    name: "liveBroad",
    component: () => import("../views/live/index.vue"),
    meta: {
      title: "鸿蒙公司成立27周年纪念大会",
      noNeedCheckLogin: true,
    },
  },



];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

export default router;
